import { useEffect } from 'react'
import { hideLoading } from 'react-redux-loading-bar'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { getNavLink } from 'featureSliced/shared/utils/getNavLink'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'

import { ModalsSlice } from 'featureSliced/shared/store/reducers/ModalsReducer'
import { Button } from 'featureSliced/entities/Button'

import box from 'assets/boxImage.svg'
import {
  NetworkErrorContainer,
  NetworkErrorTitle,
  NetworkErrorSubtitle,
  NetworkErrorTip,
} from './styled'

export const NetworkError = () => {
  const t = useTranslations()
  const navigate = useNavigate()
  const dispatch = useMyDispatch()
  const [searchParams] = useSearchParams()
  const { closeAllModals } = ModalsSlice.actions

  useEffect(() => {
    dispatch(hideLoading())
    dispatch(closeAllModals())
  }, [])

  return (
    <NetworkErrorContainer>
      <NetworkErrorTitle>{t('errors.commonErrorMessage')}</NetworkErrorTitle>
      <NetworkErrorSubtitle>
        {t('errors.internetErrorMessage')}
      </NetworkErrorSubtitle>
      <img src={box} alt="Error" />
      <NetworkErrorTip>
        Please check your internet settings and try again
        {t('errors.internetWarning')}
      </NetworkErrorTip>
      <Button
        buttonType="common"
        onClick={() => navigate(getNavLink(searchParams, ''))}
      >
        {t('buttons.refresh')}
      </Button>
    </NetworkErrorContainer>
  )
}

export default NetworkError
